export function AddOnServices() {
  const addons = [
    { name: 'Copy Editing', price: 'From $299', icon: 'ri-edit-2-line' },
    { name: 'Developmental Editing', price: 'From $599', icon: 'ri-file-edit-line' },
    { name: 'Ghostwriting', price: 'From $2,999', icon: 'ri-quill-pen-line' },
    { name: 'Audiobook Production', price: 'From $799', icon: 'ri-mic-line' },
    { name: 'Spanish Translation', price: 'From $499', icon: 'ri-translate-line' },
    { name: 'Book Trailer Creation', price: 'From $399', icon: 'ri-movie-2-line' },
    { name: 'Press Release Placement', price: 'From $299', icon: 'ri-article-line' },
    { name: 'Bookstore Visibility Campaign', price: 'From $699', icon: 'ri-store-2-line' },
    { name: 'Illustration Services', price: 'From $399', icon: 'ri-brush-line' }
  ];

  return (
    <section className="bg-[#0F0F0F] py-28">
      <div className="max-w-[1400px] mx-auto px-8">
        <h2 className="text-white text-5xl font-bold text-center mb-16">
          Additional Services
        </h2>

        <div className="grid grid-cols-3 gap-5">
          {addons.map((addon, index) => (
            <div 
              key={index}
              className="bg-[#1C1C1C] rounded-xl p-8 border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i className={`${addon.icon} text-[#D4AF37] text-4xl`}></i>
              </div>
              <h3 className="text-white text-lg font-medium mb-2">
                {addon.name}
              </h3>
              <p className="text-[#D4AF37] text-sm font-medium">
                {addon.price}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}